"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _SearchService = _interopRequireDefault(require("@insided/destination/modules/Search/services/SearchService"));

var _results = require("@insided/destination/modules/Search/utils/results");

var _searchResult = require("./search-result");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CommunitySearchResults = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(CommunitySearchResults, _PureComponent);

  var _super = _createSuper(CommunitySearchResults);

  function CommunitySearchResults() {
    var _this;

    (0, _classCallCheck2.default)(this, CommunitySearchResults);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      topicsList: []
    });
    return _this;
  }

  (0, _createClass2.default)(CommunitySearchResults, [{
    key: "fetchMetadataForTopics",
    value: function () {
      var _fetchMetadataForTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        var _this$props, topics, loaderCallback, topicsList;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, topics = _this$props.topics, loaderCallback = _this$props.loaderCallback;
                _context.next = 3;
                return _SearchService.default.fetchMetadataForTopics(topics, loaderCallback, 'communityResults');

              case 3:
                topicsList = _context.sent;

                if (topicsList) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                this.setState(function (prevState) {
                  return {
                    topicsList: _this2.props.pageCount > 0 ? prevState.topicsList.concat(topicsList) : topicsList
                  };
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchMetadataForTopics() {
        return _fetchMetadataForTopics.apply(this, arguments);
      }

      return fetchMetadataForTopics;
    }()
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchMetadataForTopics();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(this.props.topics) === JSON.stringify(prevProps.topics)) return;
      this.fetchMetadataForTopics();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _clickCallback = _this$props2.clickCallback,
          timeConfig = _this$props2.timeConfig;
      return (0, _preact.h)("div", {
        className: "community-search-result"
      }, this.state.topicsList.map(function (topic, idx) {
        return (0, _results.isCommunityResultEvent)(topic) ? (0, _preact.h)(_searchResult.EventSearchResult, {
          hit: topic,
          key: topic.id,
          timeConfig: timeConfig
        }) : (0, _preact.h)(_searchResult.CommunitySearchResult, {
          topic: topic,
          key: topic.id,
          clickCallback: function clickCallback() {
            return _clickCallback(topic.id, idx);
          }
        });
      }));
    }
  }]);
  return CommunitySearchResults;
}(_preactCompat.PureComponent);

exports.default = CommunitySearchResults;